<template>
  <div>
    <a
      ref="dropdownLink"
      class="header__filter-link"
      :class="{ active: view.subtask_parent_field_id != null }"
      @click="$refs.dropdown.toggle($refs.dropdownLink)"
    >
      <i class="header__filter-icon iconoir-git-branch"></i>
      <span class="header__filter-name">{{ $t('gridViewSubtasks.name') }}</span>
    </a>
    <Dropdown
      ref="dropdown"
      :show-search="compatibleFields.length > 6"
      :show-input="false"
      :value="view.subtask_parent_field_id"
      @input="setParentField"
    >
      <DropdownItem
        :name="$t('gridViewSubtasks.disabled')"
        :value="null"
      ></DropdownItem>
      <DropdownItem
        v-for="field in compatibleFields"
        :key="field.id"
        :name="field.name"
        :value="field.id"
      ></DropdownItem>
      <DropdownItem
        v-if="canCreateField"
        :name="$t('gridViewSubtasks.createParentField')"
        value="create-parent-field"
      ></DropdownItem>
    </Dropdown>
  </div>
</template>

<script>
import { notifyIf } from '@baserow/modules/core/utils/error'

export default {
  name: 'GridViewSubtasks',
  props: {
    database: { type: Object, required: true },
    table: { type: Object, required: true },
    view: { type: Object, required: true },
    fields: { type: Array, required: true },
    readOnly: { type: Boolean, required: true },
    storePrefix: { type: String, required: true },
  },
  computed: {
    compatibleFields() {
      return this.fields.filter(
        (field) =>
          field.type === 'link_row' &&
          field.link_row_table_id === this.table.id &&
          !field.link_row_multiple_relationships
      )
    },
    canCreateField() {
      return (
        !this.readOnly &&
        this.$hasPermission(
          'database.table.create_field',
          this.table,
          this.database.workspace.id
        )
      )
    },
  },
  methods: {
    async setParentField(value) {
      try {
        if (value === 'create-parent-field') {
          await this.createParentField()
          return
        }
        await this.updateView(value)
      } catch (error) {
        notifyIf(error, 'view')
      }
    },
    async createParentField() {
      const { newField } = await this.$store.dispatch('field/create', {
        type: 'link_row',
        table: this.table,
        values: {
          name: this.$t('gridViewSubtasks.parentFieldName'),
          link_row_table_id: this.table.id,
          link_row_multiple_relationships: false,
          has_related_field: false,
        },
      })

      const fieldOptions = this.$store.getters[
        this.storePrefix + 'view/grid/getAllFieldOptions'
      ][newField.id]
      await this.$store.dispatch(
        this.storePrefix + 'view/grid/updateFieldOptionsOfField',
        {
          field: newField,
          values: { hidden: true },
          oldValues: { hidden: fieldOptions?.hidden || false },
        }
      )
      await this.updateView(newField.id)
    },
    async updateView(fieldId) {
      await this.$store.dispatch('view/update', {
        view: this.view,
        values: { subtask_parent_field_id: fieldId },
        readOnly:
          this.readOnly ||
          !this.$hasPermission(
            'database.table.view.update',
            this.view,
            this.database.workspace.id
          ),
      })
    },
  },
}
</script>
